export const KOT_STATUS = {
  KOT_CREATE: 8,
  KOT_COMPLETE: 9,
  KOT_COMPLETE_WITH_INVOICE: 6,
  KOT_REVERSED: 5,
  KOT_CREATED_BY_INVOICE: 12,
  KOT_PROCESSING: 14,
  INVOICE_PARTIAL: 13,
  KOT_PARTIALLY_PROCESSING: 15,
  KOT_PARTIALLY_COMPLETED: 16,
};

export const KOT_STATUS_LABEL = {
  ACTIVE: "Active",
  COMPLETE: "Completed",
  PROCESSING: "Processing",
  CREATED_BY_INVOICE: "Created by Invoice",
  INVOICED: "Invoiced",
  PARTIAL_INVOICED: "Partially Invoiced",
  REVERSED: "Reversed",
};
